module.exports = "<div class=natp-myaccount-linksContainer> {{#linkGroups}} <ul class=natp-myaccount-linkGroup data-groupname={{GroupName}}> {{#links}} <li class=natp-myaccount-link> <a class=myaccount-link title={{Display}} href={{URL}} target={{LinkTarget}}>{{Display}}</a> </li> {{/links}} </ul> {{/linkGroups}} </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/scripts/components/myAccount/template.html
// module id = 48
// module chunks = 0